// export DsfVirtualList from "./virtualList.vue";

// export const DsfVirtualList=dsf.defineLazyComponent('DsfVirtualList',()=>require("./virtualList.vue"))

export const DsfVirtualList = dsf.defineAsyncComponent("DsfVirtualList", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./virtualList.vue")
);
export const DsfVirtualScrollList = dsf.defineAsyncComponent("DsfVirtualScrollList", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./virtualScrollList.vue")
);